const ReferentIntegrated = ({language , token}) => {
    const newReferentIframe = "https:" +
    window.process.env.URL_Referent
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_referent_display"
        src={newReferentIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default ReferentIntegrated